import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import _ from 'lodash'
import {bindActionCreators} from "redux"
import './style.css'
import MessageList from "./_components/MessageList"
import ForumMessage from "./_components/Message"
import NRTFormInput from "../../_common/_form/FormInput"
import NRTHorizontalStack from "../../_common/_containers/HorizontalStack"
import NRTButton from "../../_common/_buttons/Button"
import moment from "moment"
import NRTFormStateManager from "../../_common/_form/FormStateManager"
import NRTTextInput from "../../_common/_controlled-inputs/TextInput";
import createConnectedInput from "../../../redux/actions-reducers/form/create-connected-input";
import {FORM_TUTORIA_NAME} from "../../../_pages/Account/_pages/CourseList/_pages/Course/_partials/Tutoria/form-reducer";
import createFormActions from "../../../redux/actions-reducers/form/create-form-actions";

const createInput = createConnectedInput(FORM_TUTORIA_NAME)
const MessageInput = createInput('message', NRTTextInput)


class NRTForumMessages extends React.Component {

    componentDidMount() {
        this.props.resetForm()
    }

    sendMessage = () => {

        const message = _.get(this.props, 'form.values.message', '') + ''

        if (message.trim().length === 0) return

        this.props.onSendMessage(message)
        this.props.resetForm()
    }


    fileChanged = async (formFile) => {

        if (!(formFile &&
            formFile.valid &&
            formFile.values.file))
            return

        const fileUrl = formFile.values.file
        const fileName = decodeURIComponent(fileUrl).substring(fileUrl.lastIndexOf("/") + 1)

        this.props.onSendMessage(fileName, fileUrl)
    }


    render() {

        const {messages, loadingChat, upload} = this.props

        if (!messages)
            return null

        const hasMessages = messages.length > 0

        return (
            <div className='nrt-ead-forum-messages'>
                <MessageList>
                    {
                        hasMessages &&
                        messages.map(message => (
                            <ForumMessage
                                key={"fp_" + message.code}
                                author={message.personPostName}
                                sentByUser={message.personPostCode === this.props.prsCode}
                                date={moment(message.postDate)}
                                file={message.fileUrl}
                                history={this.props.history}
                                text={message.post}/>
                        ))
                    }
                    {
                        !hasMessages &&
                        <p> Não existem postagens no momento</p>
                    }
                </MessageList>

                <div style={{
                    padding: '1rem',
                    borderBottom: '1px solid #e2e2e2',
                    borderLeft: '1px solid #e2e2e2',
                    borderRight: '1px solid #e2e2e2',
                    background: '#fff'


                }}>
                    <NRTHorizontalStack fractions={upload ? [4, .5, 1] : [4, 1]}>

                        <MessageInput
                            {...{onEnterPressed: this.sendMessage}}
                        />


                        {
                            upload &&
                            <NRTFormStateManager ref={f => this.formFile = f}
                                                 onStateChange={this.fileChanged}>


                                <NRTFormInput
                                    name={"file"}
                                    type={"file"}
                                    customProps={{
                                        shouldUploadToS3: true,
                                        s3ParentType: `Versao/${this.props.release.code}/arquivos`,
                                        shortVersion: true
                                    }}
                                />
                            </NRTFormStateManager>
                        }

                        <NRTButton onClick={this.sendMessage} loading={loadingChat && true} content={'enviar'}/>
                    </NRTHorizontalStack>
                </div>
            </div>
        )
    }
}


NRTForumMessages.propTypes = {
    onSendMessage: PropTypes.func.isRequired,
    messages: PropTypes.array.isRequired,
    prsCode: PropTypes.number.isRequired,
}

NRTForumMessages.defaultProps = {}


const mapStateToProps = (state) => {
    return {
        form: state[FORM_TUTORIA_NAME]
    }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
    resetForm: createFormActions(FORM_TUTORIA_NAME).reset
}, dispatch)


export default connect(mapStateToProps, mapDispatchToProps)(NRTForumMessages)




// WEBPACK FOOTER //
// ./src/components/_ead/ForumMessages/index.js